import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import {
  getOrderTeamMemberListData,
  processAfterAddOrChangeOrderTeamMemberListData,
  processAfterDeleteOfOrderTeamMemberListData,
} from './mockData'

const postOrderTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(
    req,
    res,
    ctx,
    getOrderTeamMemberListData,
    processAfterAddOrChangeOrderTeamMemberListData
  )
}

const patchOrderTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getOrderTeamMemberListData, [
    processAfterAddOrChangeOrderTeamMemberListData,
  ])
}

const deleteOrderTeamMember = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(
    req,
    res,
    ctx,
    getOrderTeamMemberListData,
    processAfterDeleteOfOrderTeamMemberListData
  )
}

export const handlers = [
  {
    method: 'post',
    path: '/api/orderteammembers',
    handler: postOrderTeamMember,
  },
  {
    method: 'patch',
    path: '/api/orderteammembers/:id',
    handler: patchOrderTeamMember,
  },
  {
    method: 'delete',
    path: '/api/orderteammembers/:id',
    handler: deleteOrderTeamMember,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
